<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="350" v-if="useorder||daiGuansend"><strong>待发货</strong><span class="badge"
                                                                            v-if="statusnumber350>0">{{statusnumber350}}</span>
        </el-menu-item>
        <el-menu-item index="400" v-if="useorder">待邮寄<span class="badge"  v-if="statusnumber400>0">{{statusnumber400}}</span></el-menu-item>
        <el-menu-item index="500" v-if="useorder">已发货</el-menu-item>
        <el-menu-item index="810" v-if="usepurchase">待收货</el-menu-item>
        <el-menu-item index="820" v-if="usepurchase">已收货</el-menu-item>
        <el-menu-item index="660" v-if="usereturnflow">退货处理<span class="badge" v-if="statusnumber660>0">{{statusnumber660}}</span>
        </el-menu-item>
        <el-menu-item index="storeyituihuo" v-if="usereturnflow">已退货</el-menu-item>
        <el-menu-item index="storagewarn" v-if="storebasic">镜片库存</el-menu-item>
        <el-menu-item index="storageframe" v-if="storebasic">镜架库存</el-menu-item>
        <el-menu-item index="allocation" v-if="showdiaobo">调拨<span class="badge"
                                                                   v-if="statusnumberdiaobo>0">{{statusnumberdiaobo}}</span>
        </el-menu-item>
        <el-menu-item index="makeinventory" v-if="storebasic">盘点</el-menu-item>
        <el-menu-item index="badstore" v-if="storebad">坏件库<span class="badge"
                                                                v-if="statusnumberhuaijian>0">{{statusnumberhuaijian}}</span>
        </el-menu-item>
        <!--<el-menu-item index="workload">工作量</el-menu-item>-->
        <el-menu-item index="all" v-if="useorder">全部</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :canMultySelect="canMultySelect" :roletype="'store'" :mystatus="status"
               v-if="visible" @bindTip="bindTip"></comment>
    </el-main>
  </div>
</template>
<script>
  import StorageBad from '../../warehouse/StorageBad'
  import StorageWarn from '../warehouse/StorageWarn'
  import StorageFrame from '../warehouse/StorageFrame'
  import CstagreementList from './CstagreementList';
  import Workload from './Workload';
  import AllocationListNew from '../../warehouse/AllocationListNew';
  import WarehouseIndexNew from '../../warehouse/WarehouseIndexNew';
  import {countlist} from '@/api/set/csagreement';
  import {checkModuleRight, getModuleRight} from '@/api/login'

  export default {
    data() {
      return {
        useorder: false,
        storebasic: false,
        usepurchase: false,
        storebad: false,
        daiGuansend:false,
        usereturnflow: false,
        activeIndex: '350',
        currentcomponent: 'CstagreementList',
        visible: true,
        status: '350',
        statuseslist: "350;400;660;",
        statusnumber350: 0,
        statusnumber400: 0,
        statusnumber660: 0,
        statusnumberdiaobo: 0,
        statusnumberhuaijian: 0,
        showdiaobo: false,
        canMultySelect: true
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        if (key == "store" || key == "makeinventory" ) {
          this.currentcomponent = 'WarehouseIndexNew'
          this.canMultySelect = true
        } else if (key == "allocation") {
          this.currentcomponent = 'AllocationListNew'
        } else if (key == "storagewarn") {
          this.currentcomponent = 'StorageWarn';
        } else if (key == "storageframe") {
          this.currentcomponent = 'StorageFrame';
        } else if (key == "workload") {
          this.currentcomponent = 'workload'
        } else if (key == "badstore") {
          this.currentcomponent = 'StorageBad'
        } else {
          this.currentcomponent = 'CstagreementList'
        }
        this.$nextTick(() => {
          this.visible = true
        })
      },
      bindTip() {
        this.statusnumber350 = 0
        this.statusnumber400 = 0
        this.statusnumber660 = 0
        this.statusnumberdiaobo = 0;
        this.statusnumberhuaijian = 0
        countlist({
          statuseslist: this.statuseslist,
          roletype: "store",
          currentcomponent: this.currentcomponent
        }).then(response => {
          response.data.obj.forEach(item => {
            if (item.status == 350) {
              this.statusnumber350 = item.number
            } else if (item.status == 400) {
              this.statusnumber400 = item.number
            } else if (item.status == 660) {
              this.statusnumber660 = item.number
            } else if (item.status == 901) {//调拨
              this.statusnumberdiaobo = item.number
            } else if (item.status == 902) {
              this.statusnumberhuaijian = item.number
            }
          })
        })
      }
    },
    mounted() {
      getModuleRight().then(reponse => {
        this.daiGuansend=JSON.parse(localStorage.getItem("hpapi_userInfoModel")).myright.indexOf('代管仓库发货') != -1;
        if(this.daiGuansend) reponse.data.right='';

        var rightlist = ';' + reponse.data.right + ';';
        this.showdiaobo = rightlist.indexOf(';storemultip;') > -1;//多仓库关联
        this.usepurchase = rightlist.indexOf(';usepurchase;') > -1;//采购单
        this.storebad = rightlist.indexOf(';storebad;') > -1;//坏件库
        this.usereturnflow = rightlist.indexOf(';usereturnflow;') > -1;//退货处理流程
        this.storebasic = rightlist.indexOf(';storebasic;') > -1;//仓库管理
        this.useorder = rightlist.indexOf(';usewriteorder;') > -1 || rightlist.indexOf(';useweborder;') > -1;//订单管理
        this.bindTip();
      });
    },
    components: {
      CstagreementList,
      WarehouseIndexNew,
      AllocationListNew,
      StorageBad,
      StorageWarn,
      StorageFrame,
      Workload
    }

  }


</script>
<style scoped>

  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width:100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
    font-size: 13px;
    padding: 0 18px !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background: linear-gradient(135deg, #f8f9fc 0%, #eef1f7 100%);
    border-radius: 6px 6px 0 0;
    padding: 0 4px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background: transparent;
    color: #409eff;
  }

  .el-menu--horizontal .el-menu-item.is-active {
    border-bottom: 3px solid #409eff !important;
    color: #222 !important;
    font-weight: 600;
    background: transparent !important;
  }

  .el-menu--horizontal .el-menu-item .badge {
    display: inline-block;
    line-height: 16px;
    font-size: 11px;
    min-width: 16px;
    height: 16px;
    background: linear-gradient(135deg, #f56c6c, #e24545);
    color: #fff;
    text-align: center;
    border-radius: 8px;
    position: relative;
    top: -8px;
    margin-left: 3px;
    padding: 0 4px;
    box-shadow: 0 2px 4px rgba(245,108,108,0.3);
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Store.vue